import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid } from "@material-ui/core";
import styles from "../setting.module.css";
import Alert from "../../../components/UI/alert";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import AuthCode from "react-auth-code-input";
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { setCount } from "../../../store/actions/authActions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  height: 440,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

export default function AuthenticationModal(props) {
  const {
    setOpen,
    open,
    setOpenedAccount /* setSuccess */,
    setOpenedEmail,
    setVerificationID,
  } = props;
  const axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.auth.count);
  const email = useSelector((state) => state.auth.email);
  const [result, setResult] = useState();
  const [attempts, setAttempts] = useState(3);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    if (open) {
      setOpenedAccount(false);
      dispatch(setCount(60));
    }
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (counter === 60) {
      loadData();
    }
    counter > 0 && setTimeout(() => dispatch(setCount(counter - 1)), 1000);
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    if (result?.length === 6) {
      submit();
    }
    // eslint-disable-next-line
  }, [result]);

  const handleOnChange = (res) => {
    setResult(res);
  };

  const loadData = async (e) => {
    try {
      await axios.get("/pincode/request/EMAIL_CHANGE");
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "error",
            message: error.response?.data?.message,
          });
        }, 5000);
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something was wrong!",
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "error",
            message: "Something was wrong!",
          });
        }, 5000);
      }
    }
  };

  const submit = async (e) => {
    try {
      const { data } = await axios.post("/pincode/verify", {
        pincode: result,
      });
      setAttempts(data.attempts_remaining);
      if (data.message === "PIN Code verified!") {
        setVerificationID(data?.verification_id);
        setTimeout(() => {
          setOpenedEmail(true);
        }, 1000);
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: data.message,
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "error",
            message: data.message,
          });
        }, 7000);
      }
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "error",
            message: error.response?.data?.message,
          });
        }, 7000);
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something was wrong!",
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "error",
            message: "Something was wrong!",
          });
        }, 7000);
      }
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => counter === 0 && setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container style={{ marginTop: "2rem" }}>
            <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-2.5rem", marginRight: "-1rem" }}>
              <ModalCloseButton style={{ position: "static" }} onClick={() => setOpen(false)} />
            </Grid>
            <Grid item md={12}>
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{ marginTop: "-3rem" }}
              >
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <p className={styles.AuthenticationModelText}>
                    Authentication
                  </p>
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <p style={{ marginTop: "-2rem" }}>
                    Authentication code has been sent to your email
                  </p>
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <p style={{ marginTop: "-1rem" }}>{email}</p>
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <p style={{ marginTop: "0rem" }}>
                    Please enter the code below
                  </p>
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <AuthCode
                    onChange={handleOnChange}
                    containerClassName="container"
                    inputClassName={styles.input}
                    allowedCharacters={"numeric"}
                  />
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {alert.showAlert && alert.message === "PIN Code invalid" ? (
                    counter > 0 ? (
                      <p className={styles.errorMessage}>
                        Incorrect code. You have {attempts} attempts left.
                      </p>
                    ) : (
                      <p className={styles.errorMessage}>
                        Incorrect code. Please resend the code.
                      </p>
                    )
                  ) : (
                    <p className={styles.errorMessage}></p>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{ marginTop: "1rem" }}
              >
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <p className={styles.HaveRecevedText}>Haven’t received?</p>
                </Grid>
                <Grid
                  item
                  md={10}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {counter > 0 ? (
                    <p>
                      Resend the code after{" "}
                      <span className={styles.ReSendText}>{counter}s</span>
                    </p>
                  ) : (
                    <p
                      className={styles.ReSendText}
                      style={{ cursor: "pointer" }}
                      onClick={() => dispatch(setCount(60))}
                    >
                      Resend the code
                    </p>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {alert.showAlert && !alert.message === "PIN Code invalid" ? (
            <Alert
              showAlert={alert.showAlert}
              severity={alert.severity}
              message={alert.message}
              setAlert={setAlert}
            />
          ) : null}
        </Box>
      </Modal>
    </div>
  );
}
